var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4034_597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3909 1.10413C17.885 1.27815 16.5001 2.01356 15.5124 3.16362C15.0305 3.69607 14.668 4.32533 14.449 5.00927C14.2301 5.69321 14.1598 6.41604 14.2428 7.12935C14.9999 7.11428 15.7442 6.93041 16.4212 6.59114C17.0982 6.25188 17.691 5.76577 18.1562 5.16829C18.6242 4.60838 18.9747 3.96 19.1869 3.26176C19.399 2.56353 19.4684 1.82975 19.3909 1.10413Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7705 9.50526C24.1927 8.75124 23.4566 8.13303 22.6141 7.69413C21.7716 7.25522 20.8431 7.00628 19.894 6.96484C17.6053 6.96484 16.636 8.04007 15.0462 8.04007C13.4066 8.04007 12.1607 6.96859 10.1809 6.96859C9.10284 7.02269 8.05418 7.33868 7.12569 7.88922C6.19719 8.43976 5.41684 9.20825 4.85216 10.1282C3.00572 12.9353 3.32219 18.2142 6.31362 22.7119C7.38385 24.3204 8.81416 26.1295 10.683 26.1457C12.3476 26.1618 12.816 25.0991 15.0699 25.0879C17.3237 25.0767 17.7523 26.1593 19.4119 26.1419C21.2807 26.1282 22.7908 24.1235 23.861 22.5151C24.5069 21.5584 25.0589 20.5416 25.5094 19.4788C24.5162 19.1181 23.6484 18.4781 23.0105 17.6358C22.3726 16.7935 21.9917 15.7848 21.9136 14.731C21.8355 13.6773 22.0637 12.6235 22.5705 11.6963C23.0774 10.7692 23.8414 10.0083 24.7705 9.50526Z",
    fill: "#191919"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4034_597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.577,
    height: 26.1628,
    fill: "white",
    transform: "translate(0 0.500366)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.5f95d5e6b08affc76318432356d5fb28.svg";
export { ForwardRef as ReactComponent };